import { Alerts } from "../../../utils/Alerts.js";
import { useCurrentUser } from "../../AuthWrapper2/hooks/useCurrentUser.js";
import { useRPCContext } from "../../../contexts/RPCContext.js";
import { CommentForm } from "../../../components/Comments/CommentForm.js";
import { Comments } from "../../../components/Comments/Comments.js";
import { usePaginationState } from "../../../hooks/usePaginationState/index.js";
import { useEventComments } from "../hooks/useEventComments.js";
import { useCallback } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Events/components/EventComments.tsx
var EventComments = ({ eventId }) => {
	const { rpcService } = useRPCContext();
	const user = useCurrentUser();
	const { recordsPerPage, setRecordsPerPage, setSkippedRecords, skippedRecords } = usePaginationState("comments", []);
	const { data, loading, refresh } = useEventComments({ eventId });
	const handleDeleteComment = useCallback(async ({ id }) => {
		try {
			await rpcService.Events.DeleteEventComment.v1.call({ commentId: id });
			await refresh();
			Alerts.success(`Comment Deleted`);
		} catch (err) {
			Alerts.error("There was a problem deleting the comment.", err.message);
			console.log("handleDeleteComment() err", err);
		}
	}, []);
	const handleEditComment = useCallback(async ({ body, fileUrls, id }) => {
		if (!id) return;
		try {
			await rpcService.Events.UpdateEventComment.v1.call({ comment: {
				body,
				fileUrls,
				id
			} });
			await refresh();
			Alerts.success(`Comment Updated`);
		} catch (err) {
			Alerts.error("There was a problem updating the comment.", err.message);
			console.log("handleEditComment() err", err);
		}
	}, []);
	return /* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx(CommentForm, { onSubmit: (values) => rpcService.Events.CreateEventComment.v1.call({
		comment: values,
		eventId
	}).then(() => refresh()).catch((err) => {
		console.log("Events.CreateEventComment.v1.call() err", err);
		Alerts.error("There was a problem posting comment", err.message);
	}) }), /* @__PURE__ */ jsx(Comments, {
		checkCanEditComment: (comment) => user.superAdmin || user.id === comment.createdByUser?.id,
		formPosition: "top",
		onPageClick: setSkippedRecords,
		comments: data?.comments,
		commentsPerPage: recordsPerPage,
		loading,
		skippedComments: skippedRecords,
		onEdit: handleEditComment,
		onDelete: handleDeleteComment,
		onCommentsPerPageChange: setRecordsPerPage,
		totalComments: data?.comments.length
	})] });
};
//#endregion
export { EventComments };

//# sourceMappingURL=EventComments.js.map